"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublisherHandler = void 0;
const message_1 = require("../message");
const base_handler_1 = require("./base_handler");
class PublisherHandler extends base_handler_1.BaseHandler {
    constructor(connection, id) {
        super(connection, id);
    }
    async destroy() {
        await this.sendRequest(message_1.MessageType.DESTROY_PUBLISHER, {
            publisher_id: this.id,
        });
        this.cleanUp();
    }
    async publish(message) {
        await this.sendRequest(message_1.MessageType.PUBLISHER_MESSAGE, {
            publisher_id: this.id,
            message: message,
        });
    }
}
exports.PublisherHandler = PublisherHandler;
